
import { onMounted } from 'vue'
export default {
  name: 'Skeleton',
  props: {
    shape: {
      type: String as () => 'rectangle' | 'circle',
      default: 'rectangle',
    },
    color: {
      type: String as () => 'light' | 'dark',
      default: 'dark',
    },
    infinite: Boolean,
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '1rem',
    },
  },
  setup(props) {
    const baseClass = 'skeleton'
    const classes = [
      baseClass,
      {
        [`${baseClass}--${props.shape}`]: props.shape,
        [`${baseClass}--${props.color}`]: props.color,
        [`${baseClass}--infinite`]: props.infinite,
      },
    ]
    onMounted(() => {
      const skeleton = document.getElementsByClassName(baseClass) as HTMLCollectionOf<HTMLElement>
      for (let i = 0; i < skeleton.length; i++) {
        const line = skeleton[i]
        line.classList.add(`${baseClass}--animated`)
        line.addEventListener('animationend', () => {
          line.classList.remove(`${baseClass}--animated`)
        })
      }
    })
    return {
      baseClass,
      classes,
    }
  },
}
